<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="发放导入结果"
    :visible.sync="dialogFormVisible"
  >
    <div class="dialog-content">
      结果导入失败，请点击下载导入结果并检查失败原因，完成修改后重新导入。
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >下载导入结果</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      downloadId: "",
      type: "",
      dialogFormVisible: false,
      btnLoading: false
    };
  },
  watch: {},
  computed: {},
  watch: {},
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    async openDialog(downloadId, type) {
      this.downloadId = downloadId;
      this.type = type;
      this.dialogFormVisible = true;
      console.log("打开弹框", downloadId);
    },
    // 确认审核通过
    submitBtnFun() {
      this.global
        .exportExcel(
          `/autoapp-default-server-recovery/api/oldMachineSubsidy/downloadWdSubsidyIssuedFial/${this.downloadId}/${this.type}`,
          {},
          "发放导入结果"
        )
        .catch(res => {
          let blob = new Blob([res.response.data], {
            type: "application/json"
          });
          var blobReader = new Response(blob).json();
          blobReader.then(res => {
            this.$message.error(res.message);
          });
        });
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldMachineSubsidy/components/BatchReviewImportResultDialog.vue